module.exports = __webpack_public_path__ + "static/img/lun_4.7265019.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lun_4.jpg
// module id = o7F9
// module chunks = 1